import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";

const CompanyWarehouseModal = ({
    show,
    onClose,
    heading,
    initialData,
    onSuccess,
}) => {
    const initialFormState = {
        name: "",
        company_id: "",
        // code: "",
        type: "",
        location_id: "",
        email: "",
        phone: "",
    };

    const [formData, setFormData] = useState(initialFormState);
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);

    const generateCode = (name) =>
        name?.toUpperCase().replace(/\s+/g, "_").substring(0, 10);

    const fetchLocations = async () => {
        const company_id = localStorage.getItem("companyID");
        const res = await axios.get(
            `${API_URL}/company-locations/${company_id}`
        );
        setLocations(res.data.data || []);
    };

    useEffect(() => {
        const company_id = localStorage.getItem("companyID");
        fetchLocations();

        if (initialData) {
            setFormData(initialData);
        } else {
            setFormData({ ...initialFormState, company_id });
        }
    }, [initialData, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "name") {
            setFormData((prev) => ({
                ...prev,
                name: value,
                code: generateCode(value),
            }));
            return;
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            if (initialData?.id) {
                await axios.put(
                    `${API_URL}/company-warehouses/${initialData.id}`,
                    formData
                );
            } else {
                await axios.post(`${API_URL}/company-warehouses`, formData);
            }

            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Warehouse saved successfully",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            onClose();
            onSuccess();
        } catch (err) {
            Swal.fire(
                "Error",
                err.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <label className="form-label">Warehouse Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* <div className="col-md-6 mb-3">
                        <label className="form-label">Code</label>
                        <input
                            type="text"
                            className="form-control"
                            value={formData.code}
                            readOnly
                        />
                    </div> */}

                    <div className="col-md-12 mb-3">
                        <label className="form-label">Type</label>
                        <select
                            className="form-select"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Type</option>
                            <option value="Finish">Finish</option>
                            <option value="Raw Material">Raw Material</option>
                            <option value="Scrap">Scrap</option>
                            <option value="Rejection">Rejection</option>
                            <option value="Consignee Stock">Consignee Stock</option>
                            <option value="Stock With Consignor">Stock With Consignor</option>
                            <option value="Production Floor_WIP">Production Floor_WIP</option>
                            <option value="Client Material">Client Material</option>
                            <option value="Service Vendor">Service Vendor</option>
                            <option value="Others">Others</option>
                            <option value="Reserve">Reserve</option>
                            <option value="Internal Quality Checking">Internal Quality Checking</option>
                        </select>
                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label">Location</label>
                        <select
                            className="form-select"
                            name="location_id"
                            value={formData.location_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Location</option>
                            {locations.map((l) => (
                                <option key={l.id} value={l.id}>
                                    {l.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Email Address</label>
                        <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Contact Number</label>
                        <input type="number" name="phone" className="form-control" value={formData.phone} onChange={handleChange} required />
                    </div>
                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CompanyWarehouseModal;
